import React from 'react'
import PropTypes from 'prop-types'
import numeral from 'numeral'

function Progressbar({
  value, maxValue, labelSize, currency, compare, compareValue, barColor, format,
}) {
  const barWidth = {
    width: `${(value / maxValue) * 100}%`,
  }

  if (compare) {
    barColor = value < compareValue ? 'is-negative' : ''
  }

  if (!format) {
    if (value >= 10) {
      format = '0,0'
    } else if (value > 1) {
      format = '0.0'
    } else if (value >= 0.01) {
      format = '0.00'
    } else {
      format = '0'
    }
  }

  return (
    <div className="analytics-col">
      <label className={`progress-label ${labelSize}`}>{currency}{numeral(value).format(format)}</label>
      <div className="progress">
        <div className={`progress-bar ${barColor}`} style={barWidth} />
      </div>
    </div>
  )
}

Progressbar.propTypes = {
  value: PropTypes.number.isRequired,
  maxValue: PropTypes.number.isRequired,
  labelSize: PropTypes.string,
  currency: PropTypes.string,
  compare: PropTypes.bool,
  compareValue: PropTypes.number,
  barColor: PropTypes.string,
  format: PropTypes.string,
}

Progressbar.defaultPropTypes = {
  labelSize: null,
  currency: '$',
  compare: false,
  compareValue: null,
  barColor: null,
}

export default Progressbar
